import dayjs from "utils/dayjs";

const formatDateTime = (datetime: Date) => {
    const dayJsDate = dayjs(datetime);
    const prefix = dayJsDate.isToday()
        ? "Today"
        : dayJsDate.isTomorrow()
          ? "Tomorrow"
          : dayJsDate.format("dddd");

    return `${prefix}, ${dayJsDate.format("Do MMMM, h:mmA")}`;
};

export default formatDateTime;
